import { render, staticRenderFns } from "./layer-pop.vue?vue&type=template&id=dad4a968&scoped=true&"
import script from "./layer-pop.vue?vue&type=script&lang=js&"
export * from "./layer-pop.vue?vue&type=script&lang=js&"
import style0 from "./layer-pop.vue?vue&type=style&index=0&id=dad4a968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad4a968",
  null
  
)

export default component.exports